// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CaseTypeModel {
    'caseTypeId'?: number;
    'caseTypeCategoryCode'?: string;
    'caseTypeCategoryDescription'?: string;
    'caseTypeCode'?: string;
    'caseTypeDescription'?: string;
    'caseTypeCategoryId'?: number;
    'createdFromIntake'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CaseTypeModel>> = [
        {
            "name":     "caseTypeId",
            "baseName": "caseTypeId",
            "type":     "number"
        },
        {
            "name":     "caseTypeCategoryCode",
            "baseName": "caseTypeCategoryCode",
            "type":     "string"
        },
        {
            "name":     "caseTypeCategoryDescription",
            "baseName": "caseTypeCategoryDescription",
            "type":     "string"
        },
        {
            "name":     "caseTypeCode",
            "baseName": "caseTypeCode",
            "type":     "string"
        },
        {
            "name":     "caseTypeDescription",
            "baseName": "caseTypeDescription",
            "type":     "string"
        },
        {
            "name":     "caseTypeCategoryId",
            "baseName": "caseTypeCategoryId",
            "type":     "number"
        },
        {
            "name":     "createdFromIntake",
            "baseName": "createdFromIntake",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return CaseTypeModel.attributeTypeMap;
    }
}
